import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { API_ENDPOINTS, apiCall } from '../config/api';
import { useAuth } from './AuthContext';

const WalletContext = createContext();

export const useWallet = () => {
  const context = useContext(WalletContext);
  if (!context) throw new Error('useWallet must be used within WalletProvider');
  return context;
};

export const WalletProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchMyWallet = useCallback(async () => {
    if (!isAuthenticated || user?.role !== 'user') return;
    try {
      setLoading(true);
      const res = await apiCall(API_ENDPOINTS.WALLET_MY);
      if (res.ok) {
        const data = await res.json();
        setWallet(data.data || null);
      } else {
        setWallet(null);
      }
    } catch {
      setWallet(null);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user?.role]);

  useEffect(() => {
    if (isAuthenticated && user?.role === 'user') {
      fetchMyWallet();
    } else {
      setWallet(null);
    }
  }, [isAuthenticated, user?.role, fetchMyWallet]);

  const balancePaise = Number(wallet?.balancePaise || 0);
  const balanceRupees = balancePaise / 100;
  const isActive = wallet?.status === 'active';

  return (
    <WalletContext.Provider value={{
      wallet,
      balancePaise,
      balanceRupees,
      isActive,
      loading,
      refreshWallet: fetchMyWallet,
    }}>
      {children}
    </WalletContext.Provider>
  );
};
